/* Haven free-gift rules, enforced on every page.
   Gifts follow the number of Haven umbrellas in the cart: sleeve = one per umbrella,
   shoe covers = 1 at 3+, rain poncho = 1 at 5+. Retired gifts (e-book, phone pouch) = 0.
   No umbrellas in the cart means no gift lines. */
(function () {
  'use strict';
  if (window.ceGifts) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var UMB = 'haven-umbrella';
  var RULE = {
    53969265394027: function (u) { return u; },
    53969265426795: function (u) { return u >= 3 ? 1 : 0; },
    53969521541483: function (u) { return u >= 5 ? 1 : 0; },
    53969521508715: function () { return 0; },
    53969265492331: function () { return 0; }
  };
  var isGift = function (id) { return Object.prototype.hasOwnProperty.call(RULE, id); };

  /* fetch from a blank same-origin frame: the analytics add-to-cart hook does not see it, so gift lines are not counted as adds */
  var quiet = function () {
    try {
      var f = document.getElementById('ceQuietFrame');
      if (!f) { f = document.createElement('iframe'); f.id = 'ceQuietFrame'; f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; document.body.appendChild(f); }
      return f.contentWindow.fetch.bind(f.contentWindow);
    } catch (e) { return window.fetch.bind(window); }
  };
  window.ceQuietFetch = window.ceQuietFetch || quiet;

  var targets = function (cart) {
    var u = 0, have = {};
    (cart.items || []).forEach(function (it) {
      if (it.handle === UMB) u += it.quantity;
      if (isGift(it.variant_id)) have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
    });
    var diff = {}, any = false;
    Object.keys(RULE).forEach(function (id) { var want = RULE[id](u); if ((have[id] || 0) !== want) { diff[id] = want; any = true; } });
    return any ? diff : null;
  };

  var running = null, failedKey = '';
  /* resolves { cart, changed } - cart is the corrected cart when a change was needed */
  var enforce = function (cart) {
    var diff = targets(cart);
    if (!diff) return Promise.resolve({ cart: cart, changed: false });
    var key = JSON.stringify(diff);
    if (key === failedKey) return Promise.resolve({ cart: cart, changed: false });
    if (running) return running;
    running = quiet()(location.origin + ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: diff }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j || !j.items) throw j; return j; }); })
      .then(function (c) { failedKey = ''; return { cart: c, changed: true }; })
      .catch(function () { failedKey = key; return { cart: cart, changed: false }; })
      .then(function (res) { running = null; return res; });
    return running;
  };

  var refreshDawn = function (cart) {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var P = new DOMParser(), cd = document.querySelector('cart-drawer'), dst = document.querySelector('#CartDrawer');
      if (cd && dst && s['cart-drawer']) {
        var src = P.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (src) { dst.innerHTML = src.innerHTML; cd.classList.toggle('is-empty', cart.item_count === 0); var ov = dst.querySelector('#CartDrawer-Overlay'); if (ov && cd.close) ov.addEventListener('click', function () { cd.close(); }); }
      }
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) { var sec = P.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section'); if (sec) b.innerHTML = sec.innerHTML; }
    }).catch(function () {});
  };

  var check = function () {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(enforce)
      .then(function (res) { if (res.changed && !window.ceSuriCart) refreshDawn(res.cart); return res; });
  };

  window.ceGifts = { isGift: isGift, targets: targets, enforce: enforce, check: check };

  /* pages without the Haven cart: check on load and after every cart change */
  var boot = function () {
    if (document.getElementById('csCart')) return;
    var t = 0, later = function () { clearTimeout(t); t = setTimeout(function () { check().catch(function () {}); }, 400); };
    var isCartMut = function (u) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(u || '')); };
    var of = window.fetch;
    if (of) window.fetch = function (input, init) { var p = of.apply(this, arguments); try { var u = typeof input === 'string' ? input : (input && input.url); if (isCartMut(u)) p.then(later, function () {}); } catch (e) {} return p; };
    var oo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { if (isCartMut(u)) this.addEventListener('loadend', later); return oo.apply(this, arguments); };
    later();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
